import React from 'react';
import { Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Header = () => {
  return (
    <header className="bg-zinc-950 border-b border-zinc-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-4">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-14 w-auto object-contain"
            />
          </div>

          {/* Contact Info */}
          <div className="hidden md:flex items-center gap-8">
            <a
              href={`tel:${companyInfo.phone.replace(/[^0-9]/g, '')}`}
              className="flex items-center gap-2 text-gray-300 hover:text-teal-400 transition-colors duration-300"
            >
              <Phone className="h-5 w-5 text-teal-400" />
              <span className="font-medium">{companyInfo.phone}</span>
            </a>
            <a
              href={`https://maps.google.com/?q=${encodeURIComponent(companyInfo.fullAddress)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-gray-300 hover:text-teal-400 transition-colors duration-300"
            >
              <MapPin className="h-5 w-5 text-teal-400" />
              <span className="font-medium">{companyInfo.city}, {companyInfo.state}</span>
            </a>
          </div>

          {/* Mobile Contact */}
          <a
            href={`tel:${companyInfo.phone.replace(/[^0-9]/g, '')}`}
            className="md:hidden flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 rounded-lg transition-colors duration-300"
          >
            <Phone className="h-4 w-4" />
            <span className="text-sm font-medium">Call Us</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
